<odl-popover class="popover" #popover autoupdate (odl-close)="onPopoverClosed()">
  <odl-button
    id="text-selection-popover-color-list"
    class="button-color"
    [class.hidden]="isSharedHighlight()"
    [description]="'TEXT_SELECTION.HIGHLIGHT_COLOR_SELECTOR' | translate"
  >
    <nr-annotation-color-button
      slot="start"
      [interactive]="false"
      [style.--annotation-color-button-background]="colorMap[currentColor()]"
      [selected]="isEditingHighlight()"
      [description]="colorLabels[currentColor()] | translate"
    ></nr-annotation-color-button>
    <odl-icon name="expand_more" slot="end"></odl-icon>
  </odl-button>

  <odl-divider
    vertical
    class="button-color-divider"
    [class.hidden]="isSharedHighlight()"
  ></odl-divider>

  <div class="buttons">
    <odl-button
      id="text-selection-popover-add-note"
      [class.hidden]="!canOpenNote()"
      [description]="'TEXT_SELECTION.ADD_NOTE' | translate"
      (click)="createNote()"
    >
      <odl-icon name="sticky_note" slot="only-icon"></odl-icon>
    </odl-button>

    <odl-button
      id="text-selection-popover-search"
      [class.hidden]="!featureFlags.isEnabled('finder')()"
      [description]="'SEARCH' | translate"
      [disabled]="!canSearch()"
      (click)="search()"
    >
      <odl-icon name="search" slot="only-icon"></odl-icon>
    </odl-button>

    <odl-button
      class="only-desktop"
      [class.hidden]="!showTeacherQuestions() || existingMaterialForSelection()"
      id="text-selection-popover-question-list"
      [description]="'TEXT_SELECTION.ADD_ACTIVITY' | translate"
    >
      <odl-icon name="question_list" slot="only-icon"></odl-icon>
    </odl-button>

    <odl-button
      class="only-desktop"
      [class.hidden]="!showTeacherQuestions() || !existingMaterialForSelection()"
      id="text-selection-popover-open-activity"
      [description]="'TEXT_SELECTION.OPEN_ACTIVITY' | translate"
      (click)="openExistingMaterial()"
    >
      <odl-icon name="question_list" slot="only-icon"></odl-icon>
    </odl-button>

    <odl-button
      class="only-desktop"
      [class.hidden]="showTeacherQuestions() || isOffline()"
      id="text-selection-popover-look-up"
      [description]="'TEXT_SELECTION.LOOK_UP' | translate"
      (click)="openTextInfo()"
    >
      <odl-icon name="look_up" slot="only-icon"></odl-icon>
    </odl-button>

    <odl-button
      id="text-selection-popover-more-options"
      [class.only-tablet]="!hasDesktopMoreActions()"
      [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
    >
      <odl-icon name="more_vert" slot="only-icon"></odl-icon>
    </odl-button>
  </div>

  <odl-menu
    class="color-menu"
    [attr.for]="'#text-selection-popover-color-list'"
    placement="bottom-start"
  >
    @for (color of colors; track $index) {
      <odl-menu-item
        [id]="'text-selection-popover-color-' + $index"
        [attr.aria-label]="colorLabels[color] | translate"
        (odl-select)="selectColor(color)"
      >
        <nr-annotation-color-button
          slot="icon"
          [interactive]="false"
          [style.--annotation-color-button-background]="colorMap[color]"
          [selected]="color === selectedColor()"
          [description]="colorLabels[color] | translate"
        ></nr-annotation-color-button>
      </odl-menu-item>
    }
  </odl-menu>

  <odl-menu [attr.for]="'#text-selection-popover-question-list'" placement="bottom-end">
    <ng-container
      [ngTemplateOutlet]="questionsMenu"
      [ngTemplateOutletContext]="{ $implicit: false }"
    ></ng-container>
  </odl-menu>

  <odl-menu [attr.for]="'#text-selection-popover-more-options'" placement="bottom-end">
    @if (existingMaterialForSelection(); as existingMaterial) {
      <odl-menu-item
        class="only-tablet"
        [class.hidden]="!showTeacherQuestions()"
        (odl-select)="openExistingMaterial()"
      >
        <odl-icon name="question_list" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.OPEN_ACTIVITY' | translate }}</span>
      </odl-menu-item>
    } @else {
      <odl-menu-item class="only-tablet" [class.hidden]="!showTeacherQuestions()">
        <odl-icon name="question_list" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.QUESTIONS' | translate }}</span>

        <ng-container
          [ngTemplateOutlet]="questionsMenu"
          slot="submenu"
          [ngTemplateOutletContext]="{ $implicit: true }"
        ></ng-container>
      </odl-menu-item>
    }

    <odl-menu-item
      [class.only-tablet]="!showTeacherQuestions()"
      [class.hidden]="isOffline()"
      (odl-select)="openTextInfo()"
    >
      <odl-icon name="look_up" slot="icon"></odl-icon>
      <span>{{ 'TEXT_SELECTION.LOOK_UP' | translate }}</span>
    </odl-menu-item>

    <odl-menu-item [class.hidden]="isSharedHighlight() || isOffline()" (odl-select)="share()">
      <odl-icon name="link" slot="icon"></odl-icon>
      <span>{{ 'TEXT_SELECTION.SHARE_LINK' | translate }}</span>
    </odl-menu-item>
    <odl-menu-item
      [class.hidden]="!isUserFromBookClub() || isSharedHighlight() || isOffline()"
      (odl-select)="sendToClub()"
    >
      <odl-icon name="bookclub" slot="icon"></odl-icon>
      <span>{{ 'TEXT_SELECTION.SEND_TO_CLUB' | translate }}</span>
    </odl-menu-item>
    <odl-menu-item
      [class.hidden]="!isEditingHighlight() || isSharedHighlight()"
      (odl-select)="delete()"
    >
      <odl-icon name="delete" slot="icon"></odl-icon>
      <span>{{ 'TEXT_SELECTION.DELETE' | translate }}</span>
    </odl-menu-item>
  </odl-menu>
</odl-popover>

<odl-tooltip for="#text-selection-popover-color-list">
  {{ 'TEXT_SELECTION.HIGHLIGHT_COLOR_SELECTOR' | translate }}
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-add-note">
  {{ 'TEXT_SELECTION.ADD_NOTE' | translate }}
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-search">
  @if (canSearch()) {
    {{ 'SEARCH' | translate }}
  } @else {
    {{ 'SEARCH_BAR.MIN_CHARACTERS' | translate: { count: minCharsToSearch() } }}
  }
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-question-list">
  {{ 'TEXT_SELECTION.ADD_ACTIVITY' | translate }}
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-open-activity">
  {{ 'TEXT_SELECTION.OPEN_ACTIVITY' | translate }}
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-look-up">
  {{ 'TEXT_SELECTION.LOOK_UP' | translate }}
</odl-tooltip>
<odl-tooltip for="#text-selection-popover-more-options">
  {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
</odl-tooltip>
@for (color of colors; track $index) {
  <odl-tooltip [attr.for]="'#text-selection-popover-color-' + $index">
    {{ colorLabels[color] | translate }}
  </odl-tooltip>
}

<ng-template #questionsMenu let-isSubmenu>
  <odl-menu-item [attr.slot]="isSubmenu ? 'submenu' : null" (odl-select)="createQuestion(false)">
    <odl-icon name="question" slot="icon"></odl-icon>
    <span>{{ 'TEXT_SELECTION.ADD_QUESTION' | translate }}</span>

    @if (canUseAi()) {
      <odl-menu-item slot="submenu" (odl-select)="createQuestion(true); $event.stopPropagation()">
        <odl-icon name="ai" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.WITH_AI' | translate }}</span>
      </odl-menu-item>

      <odl-menu-item slot="submenu" (odl-select)="createQuestion(false); $event.stopPropagation()">
        <odl-icon name="add" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.MANUALLY' | translate }}</span>
      </odl-menu-item>
    }
  </odl-menu-item>

  <odl-menu-item [attr.slot]="isSubmenu ? 'submenu' : null" (odl-select)="createQuiz(false)">
    <odl-icon name="quiz" slot="icon"></odl-icon>
    <span>{{ 'TEXT_SELECTION.ADD_QUIZ' | translate }}</span>

    @if (canUseAi()) {
      <odl-menu-item slot="submenu" (odl-select)="createQuiz(true); $event.stopPropagation()">
        <odl-icon name="ai" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.WITH_AI' | translate }}</span>
      </odl-menu-item>

      <odl-menu-item slot="submenu" (odl-select)="createQuiz(false); $event.stopPropagation()">
        <odl-icon name="add" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.MANUALLY' | translate }}</span>
      </odl-menu-item>
    }
  </odl-menu-item>

  <odl-menu-item [attr.slot]="isSubmenu ? 'submenu' : null" (odl-select)="createPublicNote()">
    <odl-icon name="sticky_note" slot="icon"></odl-icon>
    <span>{{ 'TEXT_SELECTION.ADD_PUBLIC_NOTE' | translate }}</span>
  </odl-menu-item>

  @if (canCreateVoiceQuestions()) {
    <odl-menu-item [attr.slot]="isSubmenu ? 'submenu' : null" (odl-select)="createVoiceRecording()">
      <odl-icon name="mic" slot="icon"></odl-icon>
      <span>{{ 'TEXT_SELECTION.ADD_VOICE_RECORDING' | translate }}</span>
    </odl-menu-item>
  }
</ng-template>
